/**
 * Aritmetica monetaria deterministica.
 * Tutti i calcoli avvengono in CENTESIMI (interi) per evitare gli errori
 * di arrotondamento binario dei float; l'output è in euro arrotondato a 2 dp.
 */

export const CENTS = 100;

/** Converte euro -> centesimi interi (arrotondamento half-up sul valore assoluto). */
export function toCents(value) {
  const n = Number(value);
  if (!Number.isFinite(n)) return 0;
  return Math.sign(n) * Math.round(Math.abs(n) * CENTS);
}

/** Converte centesimi -> euro. */
export function toEuros(cents) {
  return Math.round(Number(cents) || 0) / CENTS;
}

/** Arrotonda un importo in euro a 2 decimali. */
export function round2(value) {
  return toEuros(toCents(value));
}

/** Somma importi in euro con precisione di centesimo. */
export function sumMoney(values) {
  return toEuros(
    (values || []).reduce((acc, v) => acc + toCents(v), 0),
  );
}

/** Moltiplica un importo per un fattore (es. quantità) con arrotondamento finale. */
export function multiplyMoney(value, factor) {
  const f = Number(factor);
  if (!Number.isFinite(f)) return 0;
  return round2(Number(value || 0) * f);
}

/** Applica una percentuale a un importo: pctOf(200, 4) => 8. */
export function pctOf(value, percent) {
  const p = Number(percent);
  if (!Number.isFinite(p) || p === 0) return 0;
  return round2((Number(value || 0) * p) / 100);
}

/** true se |a - b| <= 1 centesimo. */
export function moneyEquals(a, b) {
  return Math.abs(toCents(a) - toCents(b)) <= 0;
}

/** Confronto: -1 | 0 | 1 */
export function moneyCompare(a, b) {
  const diff = toCents(a) - toCents(b);
  if (diff > 0) return 1;
  if (diff < 0) return -1;
  return 0;
}
